// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__62rch","approved":"Status_approved___uLEz","rejected":"Status_rejected__1tVo-","expired":"Status_expired__2jlo1","label":"Status_label__13tQp"};